import { Download, UploadFile } from "@mui/icons-material";
import LinkIcon from "@mui/icons-material/Link";
import { Box, Card, CircularProgress, Grid, Icon, IconButton, InputLabel } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDSelect from "components/MDSelect";
import MDTextArea from "components/MDTextArea";
import { MDTextFieldCalendar } from "components/MDTextFiedCalendar";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import { useUser } from "context/UserContext";
import { Form, Formik, useFormikContext } from "formik";
import FormField from "layouts/pages/users/new-user/components/FormField";
import PropTypes from "prop-types";
import { useEffect, useState } from 'react';
import { errorAlert, successAlert } from "utils/Functions";
import { get, postFile, postNoResponse } from "utils/WebService";
import * as Yup from "yup";


export default function MovimentationCreateEdit({ id, closeCreateEdit, refreshTable, casoProcessualId }) {
    const {
        movimentacao,
        informacao,
        tipoOrigem,
        tipoMovimentacao
    } = configForm.formField;

    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    const {
        fonteMovimentacaoEnum,
        tipoMovimentacaoEnum,
    } = useUser();

    const [isLoadingInfo, setIsLoadingInfo] = useState(false);
    const [isLoadingUpload, setIsLoadingUpload] = useState(false);
    const [isDownload, setIsDownload] = useState(false);

    const handleSubmit = (values, actions) => {

        const body = {
            id: values.id,
            dataMovimentacao: values.dataMovimentacao,
            movimentacao: values.movimentacao,
            informacao: values.informacao,
            link: values.link,
            tipoOrigem: values.tipoOrigem?.code,
            tipoMovimentacao: values.tipoMovimentacao?.code,
            processoId: casoProcessualId,
        };

        postNoResponse("/movimentacao-processo/save", body)
            .then(() => {
                successAlert(!id ? "Movimentação criada com sucesso!" : "Alterações salvas!", handleSucess());
            })
            .catch(() => {
                errorAlert(!id ? "Erro ao criar movimentação!" : 'Erro ao salvar alterações.');
            })
            .finally(() => {
                actions.setSubmitting(false);
            });
    };

    function handleSucess() {
        closeCreateEdit()
        refreshTable()
    }

    function handleDownloadFile(id, nomeArquivo) {
        try {
            postFile(`/movimentacao-processo/download/${id}`, {}, `${nomeArquivo}`).then((res) => {
                setIsDownload(false)
            }).catch((res) => setIsDownload(false));
        } catch (error) {
            console.error("Erro ao baixar arquivo", error);
        }
    }

    function handleUploadFile({ file, fileName, idMovimentation, reloadById }) {
        postNoResponse("/movimentacao-processo/upload", {
            idMovimentation: idMovimentation,
            base64File: file,
            nameFile: fileName,
        })
            .then(() => {
                successAlert("Upload do arquivo realizado com sucesso!");
                if (reloadById) reloadById(); // 🔄 recarrega dados após upload
            })
            .catch(() => {
                errorAlert("Erro ao realizar upload do arquivo!");
            });
    }

    const onFileChange = async ({ target }, id, reloadById) => {
        setIsLoadingUpload(true);
        const file = target.files[0];
        if (!file) return setIsLoadingUpload(false);

        try {
            const base64String = await fileToBase64(file);
            handleUploadFile({
                file: base64String,
                fileName: file.name,
                idMovimentation: id,
                reloadById, // passa função para recarregar
            });
        } catch (error) {
            console.error("Erro ao ler o arquivo: ", error);
            errorAlert("Erro ao ler o arquivo!");
        } finally {
            setIsLoadingUpload(false);
        }
    };

    function fileToBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result.split(",")[1]);
            reader.onerror = (err) => reject(err);
        });
    }


    return (
        <Card id="user-info">
            <Box display="flex" alignItems="center" p={3}>
                <IconButton onClick={closeCreateEdit} sx={{ p: 0, paddingRight: 1, paddingTop: 0.75 }}>
                    <MDTypography variant="h5">
                        <Icon>arrow_back</Icon>
                    </MDTypography>
                </IconButton>
                <MDTypography variant="h6">{id ? "Editar" : "Adicionar"} Movimentação</MDTypography>
            </Box>
            <Formik
                initialValues={{
                    id: null,
                    movimentacao: null,
                    informacao: null,
                    link: null,
                    dataMovimentacao: null,
                    nomeArquivo: null,
                    tipoOrigem: fonteMovimentacaoEnum?.find(ht => ht.code === "manual"),
                    tipoMovimentacao: tipoMovimentacaoEnum?.find(ht => ht.code === "recorte"),
                }}
                validationSchema={clientValidations}
                onSubmit={(values, actions) => {
                    actions.setSubmitting(true);
                    handleSubmit(values, actions);
                }}>
                {({ values, errors, touched, isSubmitting, setFieldValue }) => {


                    return (
                        <Form id={configForm.formId} autoComplete="off">
                            <FetchAndSetData
                                id={id}
                                setIsLoadingInfo={setIsLoadingInfo}
                                closeCreateEdit={closeCreateEdit}
                                fonteMovimentacaoEnum={fonteMovimentacaoEnum}
                                tipoMovimentacaoEnum={tipoMovimentacaoEnum}
                            />

                            <MDBox px={3}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={3}>
                                        <FormField
                                            loading={isLoadingInfo}
                                            type={movimentacao.type}
                                            label={movimentacao.label}
                                            name={movimentacao.name}
                                            value={values.movimentacao ?? ""}
                                            placeholder={movimentacao.placeholder}
                                            error={errors.movimentacao?.length > 0 && touched.movimentacao}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={3}>
                                        <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Data Início</InputLabel>
                                        <MDTextFieldCalendar
                                            type="date"
                                            name="dataMovimentacao"
                                            value={values.dataMovimentacao ?? ""}
                                            fullWidth
                                            onChange={({ target }) => {
                                                setFieldValue("dataMovimentacao", target.value)
                                            }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            darkMode={darkMode}
                                        />
                                        {errors.dataMovimentacao && touched.dataMovimentacao && (
                                            <MDTypography variant="caption" color="error">
                                                {errors.dataMovimentacao}
                                            </MDTypography>
                                        )}
                                    </Grid>

                                    <Grid item xs={12} sm={3}>
                                        <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Tipo de Movimentação</InputLabel>
                                        <MDSelect
                                            isLoading={isLoadingInfo}
                                            getOptionValue={option => option.code}
                                            getOptionLabel={option => option.name}
                                            name={tipoMovimentacao.name}
                                            placeholder={tipoMovimentacao.placeholder}
                                            value={values.tipoMovimentacao}
                                            options={tipoMovimentacaoEnum}
                                            onChange={selectedOptions => {
                                                setFieldValue('tipoMovimentacao', selectedOptions);
                                            }}
                                        />
                                        {errors.tipoMovimentacao && touched.tipoMovimentacao && (
                                            <MDTypography variant="caption" color="error">
                                                {errors.tipoMovimentacao}
                                            </MDTypography>
                                        )}
                                    </Grid>

                                    <Grid item xs={12} sm={3}>
                                        <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Origem</InputLabel>
                                        <MDSelect
                                            isLoading={isLoadingInfo}
                                            getOptionValue={option => option.code}
                                            getOptionLabel={option => option.name}
                                            name={tipoOrigem.name}
                                            placeholder={tipoOrigem.placeholder}
                                            value={values.tipoOrigem}
                                            options={fonteMovimentacaoEnum}
                                            onChange={selectedOptions => {
                                                setFieldValue('tipoOrigem', selectedOptions);
                                            }}
                                        />
                                        {errors.tipoOrigem && touched.tipoOrigem && (
                                            <MDTypography variant="caption" color="error">
                                                {errors.tipoOrigem}
                                            </MDTypography>
                                        )}
                                    </Grid>



                                    <Grid item xs={12} sm={6}>
                                        <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Informação</InputLabel>
                                        <MDTextArea
                                            rows={10}
                                            placeholder={informacao.placeholder}
                                            value={values.informacao ?? ""}
                                            onChange={({ target }) => setFieldValue('informacao', target.value)}
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Box display="flex" alignItems="center" gap={2} flexWrap="wrap" mt={2}>
                                            {values.link && (
                                                <MDButton
                                                    variant="outlined"
                                                    startIcon={<LinkIcon />}
                                                    color="info"
                                                    onClick={() => window.open(values.link, "_blank")}
                                                >
                                                    Link Arquivo
                                                </MDButton>
                                            )}

                                            <MDButton
                                                variant="contained"
                                                component="label"
                                                startIcon={!isLoadingUpload && <UploadFile />}
                                                color="info"
                                                endIcon={
                                                    isLoadingUpload ? (
                                                        <CircularProgress color="white" size={20} sx={{ ml: 0, mr: 0 }} />
                                                    ) : null
                                                }
                                            >
                                                {!isLoadingUpload && "Upload"}
                                                <input
                                                    type="file"
                                                    onChange={(e) => onFileChange(e, values.id, () => {
                                                        // 🔄 recarrega dados do by-id
                                                        get(`/movimentacao-processo/by-id/${values.id}`).then((data) => {
                                                            setFieldValue("nomeArquivo", data.nomeArquivo);
                                                            setFieldValue("link", data.link);
                                                        });
                                                    })}
                                                    hidden
                                                />
                                            </MDButton>

                                            {values.nomeArquivo && (
                                                <MDButton
                                                    variant="outlined"
                                                    startIcon={!isDownload && <Download />}
                                                    color="info"
                                                    onClick={() => handleDownloadFile(values.id, values.nomeArquivo)}
                                                    endIcon={
                                                        isDownload ? (
                                                            <CircularProgress color="white" size={20} sx={{ ml: 0, mr: 0 }} />
                                                        ) : null
                                                    }
                                                >
                                                    {!isDownload && "Baixar"}
                                                </MDButton>
                                            )}
                                        </Box>
                                    </Grid>
                                </Grid>
                            </MDBox>

                            <Box display="flex" alignItems="center" justifyContent="end" p={2}>
                                <MDButton
                                    disabled={isLoadingInfo}
                                    size="large"
                                    variant="contained"
                                    color="info"
                                    circular={false}
                                    iconOnly={false}
                                    type="submit"
                                    endIcon={isSubmitting ?
                                        <CircularProgress
                                            color="inherit"
                                            size={20} sx={{ ml: 0, mr: 0 }} /> : null}>
                                    {!isSubmitting && (id ? "Salvar" : "Adicionar")}
                                </MDButton>
                            </Box>
                        </Form>)
                }}
            </Formik>
        </Card >
    );
};

const FetchAndSetData = ({ id, setIsLoadingInfo, closeCreateEdit, fonteMovimentacaoEnum, tipoMovimentacaoEnum }) => {
    const { setFieldValue } = useFormikContext();


    useEffect(() => {
        if (id) {
            setIsLoadingInfo(true);
            get(`/movimentacao-processo/by-id/${id}`).then(data => {
                const { id,
                    movimentacao,
                    informacao,
                    dataMovimentacao,
                    link,
                    tipoOrigem,
                    tipoMovimentacao,
                    nomeArquivo } = data;

                setFieldValue('id', id);
                setFieldValue('movimentacao', movimentacao);
                setFieldValue('nomeArquivo', nomeArquivo);
                setFieldValue('informacao', informacao);
                setFieldValue('dataMovimentacao', dataMovimentacao);
                setFieldValue('link', link);
                setFieldValue('tipoOrigem', fonteMovimentacaoEnum?.find(ht => ht.code === tipoOrigem));
                setFieldValue('tipoMovimentacao', tipoMovimentacaoEnum?.find(ht => ht.code === tipoMovimentacao));
                setIsLoadingInfo(false);
            }).catch(() => errorAlert("Movimentação não encontrada!", closeCreateEdit));
        }
    }, [id]);

    return null;
};

export const configForm = {
    formId: "configuration-form",
    formField: {
        movimentacao: {
            name: "movimentacao",
            label: "Movimentação",
            type: "text",
            placeholder: "Informe a movimentação...",
            errorMsg: "Campo Obrigatório. Somente espaços em brancos não são permitidos.",
        },
        informacao: {
            name: "informacao",
            label: "Informação",
            type: "text",
            placeholder: "Informe a informação...",
        },
        dataMovimentacao: {
            name: "dataMovimentacao",
            label: "Data",
            type: "date",
            errorMsg: "Campo Obrigatório. Somente espaços em brancos não são permitidos.",
        },
        tipoOrigem: {
            name: "tipoOrigem",
            placeholder: "Selecione a Origem",
            errorMsg: "Campo Obrigatório",
        },
        tipoMovimentacao: {
            name: "tipoMovimentacao",
            placeholder: "Selecione a tipo de Movimentação",
            errorMsg: "Campo Obrigatório",
        },
    }
}

const {
    formField: {
        movimentacao,
        dataMovimentacao,
        tipoOrigem,
        tipoMovimentacao
    },
} = configForm;

export const clientValidations = Yup.object().shape({
    [movimentacao.name]: Yup.string()
        .required(movimentacao.errorMsg),
    [dataMovimentacao.name]: Yup.string()
        .required(dataMovimentacao.errorMsg),
    [tipoOrigem.name]: Yup.object()
        .required(tipoOrigem.errorMsg),
    [tipoMovimentacao.name]: Yup.object()
        .required(tipoMovimentacao.errorMsg),
});

MovimentationCreateEdit.propTypes = {
    id: PropTypes.string,
    closeCreateEdit: PropTypes.func.isRequired,
};
